/**
 * Tiny global celebration helper.
 *
 * Any component can fire a celebration overlay (color flash + burst) by calling
 * `celebrate()` — no need to wire callbacks through props.
 *
 * Why a custom event:
 *   - Zero coupling. Components stay simple toast callsites.
 *   - Works anywhere, including service workers, fetch interceptors, etc.
 *   - The single <CelebrationFlash /> overlay in AppLayout listens & renders.
 *
 * Side effect: also persists the celebration into a rolling buffer of the
 * last 5 events so the Dashboard can show a "recent achievements" strip.
 */

export const CELEBRATE_EVENT = "canales:celebrate";
export const ACHIEVEMENTS_STORAGE_KEY = "canales_recent_achievements_v1";
export const ACHIEVEMENTS_UPDATED_EVENT = "canales:achievements:updated";
const MAX_HISTORY = 5;

function pushHistory(entry) {
  if (typeof window === "undefined") return;
  try {
    const raw = window.localStorage.getItem(ACHIEVEMENTS_STORAGE_KEY);
    const prev = raw ? JSON.parse(raw) : [];
    const next = [entry, ...(Array.isArray(prev) ? prev : [])].slice(0, MAX_HISTORY);
    window.localStorage.setItem(ACHIEVEMENTS_STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new CustomEvent(ACHIEVEMENTS_UPDATED_EVENT));
  } catch (_) {
    // localStorage might be unavailable (private mode, quota). No-op.
  }
}

export function celebrate(reason = "default") {
  if (typeof window === "undefined") return;
  const entry = { reason, t: Date.now() };
  try {
    window.dispatchEvent(new CustomEvent(CELEBRATE_EVENT, { detail: entry }));
  } catch (_) {
    // no-op
  }
  pushHistory(entry);
}

export function readRecentAchievements() {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(ACHIEVEMENTS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (_) {
    return [];
  }
}

export function clearRecentAchievements() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(ACHIEVEMENTS_STORAGE_KEY);
    window.dispatchEvent(new CustomEvent(ACHIEVEMENTS_UPDATED_EVENT));
  } catch (_) {}
}
